import type Konva from "konva";

/**
 * Exportiert die Taktikkarte als PNG zum Teilen außerhalb der App.
 *
 * Die Karte wird mit Konva gerendert (Radar + Overlay in einer Stage). Der
 * Export nimmt deshalb direkt die Stage-Leinwand (`toCanvas`) und legt sie über
 * einen dunklen Hintergrund — ohne den wäre das Radar (Deckkraft 0.72) in hellen
 * Chats unlesbar, weil die Stage selbst transparent ist.
 */
export async function exportTacticImage(options: {
  stage: Konva.Stage;
  fileName: string;
  pixelRatio?: number;
}): Promise<void> {
  const { stage, fileName, pixelRatio = 2 } = options;
  const source = stage.toCanvas({ pixelRatio });

  const canvas = document.createElement("canvas");
  canvas.width = source.width;
  canvas.height = source.height;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Canvas nicht verfügbar");
  context.fillStyle = "#070b0d";
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.drawImage(source, 0, 0);

  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob(resolve, "image/png"),
  );
  if (!blob) throw new Error("Export fehlgeschlagen");
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
